<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3.90625 3.125V14.8437C3.90625 16.1382 4.95558 17.1875 6.25 17.1875H8.59375M3.90625 3.125H2.34375M3.90625 3.125H21.0937M21.0937 3.125H22.6562M21.0937 3.125V14.8437C21.0937 16.1382 20.0444 17.1875 18.75 17.1875H16.4062M8.59375 17.1875H16.4062M8.59375 17.1875L7.55208 20.3125M16.4062 17.1875L17.4479 20.3125M17.4479 20.3125L17.9687 21.875M17.4479 20.3125H7.55208M7.55208 20.3125L7.03125 21.875M7.8125 12.5L10.9375 9.375L13.1746 11.6121C14.2231 10.1073 15.5941 8.84399 17.1875 7.92228"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgPresentation',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
